var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattleTips2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F99F22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.9982C18.6274 23.9982 24 18.6257 24 11.9982C24 9.93302 23.4783 7.98966 22.5595 6.29274C20.4497 4.44906 17.6887 3.33203 14.6667 3.33203C8.03933 3.33203 2.66675 8.70461 2.66675 15.332C2.66675 17.3973 3.18846 19.3406 4.10727 21.0375C6.21704 22.8812 8.97807 23.9982 12 23.9982Z",
    fill: "#F5AB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12H5.33333M12 4.5V5.33333M18.6667 12H19.5M6.66667 6.66667L7.25 7.25M17.3333 6.66667L16.75 7.25M9.5 15.3333C8.80039 14.8086 8.28361 14.0771 8.02286 13.2424C7.76211 12.4076 7.77061 11.512 8.04715 10.6824C8.3237 9.85275 8.85427 9.13116 9.56371 8.61982C10.2731 8.10849 11.1255 7.83333 12 7.83333C12.8745 7.83333 13.7269 8.10849 14.4363 8.61982C15.1457 9.13116 15.6763 9.85275 15.9528 10.6824C16.2294 11.512 16.2379 12.4076 15.9771 13.2424C15.7164 14.0771 15.1996 14.8086 14.5 15.3333C14.1746 15.6554 13.9297 16.0495 13.7849 16.4839C13.6401 16.9182 13.5996 17.3805 13.6667 17.8333C13.6667 18.2754 13.4911 18.6993 13.1785 19.0118C12.866 19.3244 12.442 19.5 12 19.5C11.558 19.5 11.134 19.3244 10.8215 19.0118C10.5089 18.6993 10.3333 18.2754 10.3333 17.8333C10.4004 17.3805 10.3599 16.9182 10.2151 16.4839C10.0703 16.0495 9.82536 15.6554 9.5 15.3333M10.0833 16.1667H13.9167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattleTips2);
export default __webpack_public_path__ + "static/media/battleTips2.9cefa61a5ccf6040b49a44ce5b1c317f.svg";
export { ForwardRef as ReactComponent };